module.exports = __webpack_public_path__ + "static/narzugon-27186c195ec8f3f5f40d232ff1e2012e.png";